const getCustomCommissionsAPI = () => 'api/commissions/custom-commissions';

const submitCustomCommissionAPI = () => 'api/commissions/request-custom';

const updateCustomCommissionAPI = (commissionId) => `api/commissions/request-custom/${commissionId}`;

const cancelCustomCommissionAPI = (commissionId) => `api/commissions/request-custom/${commissionId}`;

const approveCustomCommissionAPI = (commissionId) => `api/commissions/approve-custom/${commissionId}`;

const declineCustomCommissionAPI = (commissionId) => `api/commissions/decline-custom/${commissionId}`;

export const commissionsEndpoints = {
  getCustomCommissionsAPI,
  submitCustomCommissionAPI,
  updateCustomCommissionAPI,
  cancelCustomCommissionAPI,
  approveCustomCommissionAPI,
  declineCustomCommissionAPI,
  getCustomCommissionsPaginationAPI: (page = 1, limit = 20, branchId) =>
    `api/commissions/custom-commissions?page=${page}&limit=${limit}&branchId=${branchId}`,
  getCommissionsHistoryPaginationAPI: (page = 1, limit = 20, branchId) =>
    `api/commissions/commission-history?page=${page}&limit=${limit}&branchId=${branchId}`,
  requestCommissionAPI: () => 'api/commissions/request-custom',
};
